import React from 'react';
import Link from 'next/link';
import { Logo } from '../../utils';

import { LogoContainer } from './styles';

const Logotype = ({ innerPage }) => (
  <LogoContainer>
    <Link href="/">
      <a>
        <Logo width="100%" height="100%" color={innerPage ? '#1eb6ff' : '#ffffff'}/>
      </a>
    </Link>
  </LogoContainer>
);

export default Logotype;
